<template>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :server-items-length="totalItems"
        :options.sync="internalOptions"
        :footer-props="{
            'items-per-page-options': [10, 25, 50, 100],
            'items-per-page-text': itemsPerPageText,
        }"
        :no-data-text="noDataText"
        :loading-text="loadingText"
        fixed-header
        :height="tableHeight"
        class="customer-list-table"
    >
        <template v-if="filterType !== 'juridica'" v-slot:[`item.fullName`]="{ item }">
            {{ item.getFullName() }}
        </template>
        <template v-if="filterType !== 'fisica'" v-slot:[`item.businessName`]="{ item }">
            {{ item.getBusinessName() }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon small @click="$emit('select-row', item)" color="primary">
                <v-icon small>mdi-pencil</v-icon>
            </v-btn>
        </template>
        <template v-slot:[`footer.page-text`]="items">
            {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
        </template>
    </v-data-table>
</template>

<script>
export default {
    name: 'CustomerListTable',
    props: {
        items: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        totalItems: {
            type: Number,
            default: 0
        },
        options: {
            type: Object,
            default: () => ({})
        },
        filterType: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            tableHeight: 'calc(88vh - 250px)'
        };
    },
    computed: {
        headers() {
            return this.buildHeaders();
        },
        internalOptions: {
            get() {
                return this.options;
            },
            set(value) {
                this.$emit('update:options', value);
            }
        },
        itemsPerPageText() {
            const textConfig = {
                fisica: 'Personas físicas por página:',
                juridica: 'Personas jurídicas por página:',
                default: 'Clientes por página:'
            };
            return textConfig[this.filterType] || textConfig.default;
        },
        noDataText() {
            const textConfig = {
                fisica: 'No hay personas físicas',
                juridica: 'No hay personas jurídicas',
                default: 'No hay clientes'
            };
            return textConfig[this.filterType] || textConfig.default;
        },
        loadingText() {
            const textConfig = {
                fisica: 'Cargando personas físicas...',
                juridica: 'Cargando personas jurídicas...',
                default: 'Cargando clientes...'
            };
            return textConfig[this.filterType] || textConfig.default;
        }
    },
    methods: {
        buildHeaders() {
            const typeHeader = { text: 'Tipo de Persona', value: 'type', sortable: true };
            const cifHeader = { text: 'CIF', value: 'cif', sortable: true };

            const physicaHeaders = [
                { text: 'Nombre del Cliente', value: 'fullName', sortable: true }
            ];

            const juridicaHeaders = [
                { text: 'Nombre Comercial', value: 'tradeName', sortable: true },
                { text: 'Razón Social', value: 'businessName', sortable: true }
            ];

            const commonHeaders = [
                { text: 'Código Postal', value: 'postCode', sortable: true },
                { text: 'Acciones', value: 'actions', sortable: false, align: 'center' }
            ];

            const headerConfigs = {
                fisica: [cifHeader, ...physicaHeaders, ...commonHeaders],
                juridica: [cifHeader, ...juridicaHeaders, ...commonHeaders],
                default: [typeHeader, cifHeader, ...physicaHeaders, ...juridicaHeaders, ...commonHeaders]
            };

            return headerConfigs[this.filterType] || headerConfigs.default;
        }
    }
};
</script>

<style lang="scss">
.customer-list-table {
    &.v-data-table {
        thead {
            th {
                background-color: var(--v-primaryLight-base) !important;
                color: var(--v-primary-base) !important;
                font-size: 0.875rem !important;
            }
        }

        tbody {
            td {
                text-transform: uppercase !important;
            }
        }
    }
}
</style>
